
import { useState,useEffect,useContext } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome,faCogs,faSuitcaseRolling,faTools,faGraduationCap,faLocationDot,faPeopleGroup, faSitemap, faPhoneSquare } from '@fortawesome/free-solid-svg-icons'
import useAxiosPrivate from "../../Hooks/useAxiosPrivate";
import useAuth from "../../Hooks/UseAuth";
import AuthContext from "../../Context/AuthProvider";



function Summary(){  
        

    const [searchData, setSearchData] = useState(""); 
      const [fildata, setFildata] = useState([]); 
    //   const auth = useAuth();
      const [userData, setUserData] = useState([]); 
      const[tData, setTData] = useState([]);
       const {auth,setAuth}= useContext(AuthContext)

      
        const [value, setValue] = useState(
            { 
        
                Locat : '',
                Fromto : "",
                Message : ""
        
            }
        )
        const [inpV, setInpV] = useState("");

        const handleFilter = (event) =>{ 
            console.log(event.target.value);
            const searchWord = event.target.value;
            const newFilter = searchData.filter((value)=>{
                console.log("searchWord",searchWord)
                 return value.name.toLowerCase().includes(searchWord.toLowerCase());
                  
            })

            setFildata(newFilter);
       }

        async function populateData(){  

            // const response = await fetch("https://superagentback.onrender.com/api/Alltransactions",{
            const response = await fetch("https://nerdayb.onrender.com/api/Alltransactions",{
                headers : { 
                //   'x-access-token' : auth.user,
                }
            // body: JSON.stringify({
            //     quote,
                
            // })
            })
            
            const data = await response.json();
            console.log("All Data here",data.propdata)
            if(data){

        if(data.status == "ok") {
            setTData(data.propdata)
            setSearchData(data.propdata)
            console.log("Data here",data)
            }else{
            //    alert(data.error,"Here!")
            console.log("testign first")
            } 

        }
        
      //   console.log(data,"aync test");
        
        return data;
        
  } 

//   useEffect(()=>{ 

//      populateData();
//      console.log("test populate");

//   },[]) 

   const handleSelected = (item) =>{
    
            // console.log("herezz",item)
            setUserData(item)
            // console.log("User",userData)

   }

   const [users, setUsers] = useState();
   const axiosPrivate = useAxiosPrivate();
 //   const navigate = useNavigate();
 //   const location = useLocation();
 
   useEffect(() => {
       let isMounted = true;
       const controller = new AbortController();
 
       const getUsers = async () => {
           try {
               const response = await axiosPrivate.get('/users', {
                   signal: controller.signal,
                   params: {
                
                    Org: auth.foundUser.Org,
                    // org: 'value2',
                    // mgtLvl: 'value2',
                  }
               });
               console.log(response.data);
               console.log("Heresummary");
               isMounted && setUsers(response.data);
               setTData(response?.data)
               setSearchData(response?.data)
           } catch (err) {
               console.error(err);
             //   navigate('/login', { state: { from: location }, replace: true });
           }
       }
       console.log("contect",auth)
       getUsers();
 
       return () => {
           isMounted = false;
           controller.abort();
       }
   }, [])
 
        


    return <>
       

            {/* input field */}
            <div className='searchBar'>  
          
          <div className='searchInputs'>
               <input type="text" name='Locat' onChange = {handleFilter} />
               <div className='ssearchIcon'> <i class="fa-solid fa-magnifying-glass"></i></div>

               { 
            fildata.length > 0 && 
            (

              <div className='dataResults'>
             {
             searchData && 
             
             fildata.map((index,key)=>{
                 
                 return (
                   <div onClick={()=>handleSelected(index)} ><a key={key} className='datItem'>{index.name}</a></div>
                   
                 )
               
             })} 
           
          </div>


            )
          }

          </div>
          </div>


        {/* <h1>In Summary</h1>  */}

        <div className="wholeCard">
                {/* <h1>In Summary</h1> */}

            <div className="compCards">  
                <div className="iconTitle"><FontAwesomeIcon icon={faSitemap} className="FontAwesomeIcon"/>Organisation</div>
                <div className="cardData"><p>{auth?.foundOrg?.Name}</p></div>

            </div>

            <div className="compCards">  
                <div className="iconTitle"><FontAwesomeIcon icon={faLocationDot} className="FontAwesomeIcon"/>Head Quarters</div>
                <div className="cardData"><p>{auth?.foundOrg?.HQ}</p></div>

            </div>
            <div className="compCards">  
                <div className="iconTitle"><FontAwesomeIcon icon={faPhoneSquare} className="FontAwesomeIcon"/>Phonenumber</div>
                {/* <div className="cardData"></div> */}
                <div className="cardData"><p>{auth?.foundOrg?.Phone}</p></div>

            </div>
           
           
        </div>
        <div className="wholeCard">
                {/* <h1>In Summary</h1> */}
            <div className="compCards">  
                <div className="cardHeading"><h2>Employee Details</h2></div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Name</b></p></div>
                    <div className="InpuTvalue">{userData.name}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Employee ID</b></p></div>
                    <div className="InpuTvalue">{userData.NRC}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Position</b></p></div>
                    <div className="InpuTvalue">{userData.Position}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Gender</b></p></div>
                    <div className="InpuTvalue">{userData.Gender}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Account_N0</b></p></div>
                    <div className="InpuTvalue">{userData.AccountNo}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Base_Pay</b></p></div>
                    <div className="InpuTvalue">{`ZMK ${userData.Base_Pay}`}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Management Level</b></p></div>
                    <div className="InpuTvalue">Level 1</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Employee Type</b></p></div>
                    <div className="InpuTvalue">{userData.Contract}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Location</b></p></div>
                    <div className="InpuTvalue">{userData.Address}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Original Hire Date</b></p></div>
                    <div className="InpuTvalue">{userData.Hire_Date}</div>

                </div>

                <div className="cardHeading"><h2>Contact Information - Public</h2></div> 

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Social Security Number</b></p></div>
                    <div className="InpuTvalue">{userData.Ssn}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Email</b></p></div>
                    <div className="InpuTvalue">{userData.email}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Phone Number</b></p></div>
                    <div className="InpuTvalue">{userData.PhoneNumber}</div>

                </div>
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Home Address</b></p></div>
                    <div className="InpuTvalue">{userData.Address}</div>

                </div>
               
               

            </div>

            <div>

            <div className="wholeCard">
                {/* <h1>In Summary</h1> */}
            <div className="compCards">  

            {/* NextofKin : req.body.nik,
                                // Ssn : req.body.address,
                                NextofKinAddress : req.body.nikAddress,
                                NextofKinContact : req.body.nikContact,
                                Hire_Date : req.body.doh,
                                Ssn : req.body.Ssn,
                                NextofKinRel : req.body.nikRel,
                                FInstitutionBranch : req.body.AccountBranch,
                                AccountType : req.body.AccountType, */}
            
   

                <div className="cardHeading"><h3>Next-of-Kin Information</h3></div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Full Name</b></p></div>
                    <div className="InpuTvalue">{userData.NextofKin}</div>

                </div>

                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Relationship</b></p></div>
                    <div className="InpuTvalue">{userData.NextofKinRel}</div>

                </div>

                {/* <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Nationality</b></p></div>
                    <div className="InpuTvalue">Zambian</div>

                </div> */}
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Contact</b></p></div>
                    <div className="InpuTvalue">{userData.NextofKinContact}</div>

                </div>
                {/* <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Phone Number</b></p></div>
                    <div className="InpuTvalue">+260970000000</div>

                </div> */}
                <div className="moreDetails">
                    <div className="InpuTsubject"><p><b>Home Address</b></p></div>
                    <div className="InpuTvalue">{userData.NextofKinAddress}</div>

                </div>

              

            </div>
          
           
        </div>
            </div>
          
           
        </div>
    
    </>

}

export default Summary;

